import { CALL_API } from 'redux-api-middleware'
import {
  BASE_URL,
  STANDARD_PRICE_GET_REQUEST,
  STANDARD_PRICE_GET_SUCCESS,
  STANDARD_PRICE_GET_FAILURE,
  STANDARD_PRICE_GET_RESET,
  STANDARD_PRICE_LIST_REQUEST,
  STANDARD_PRICE_LIST_SUCCESS,
  STANDARD_PRICE_LIST_FAILURE,
  STANDARD_PRICE_LIST_RESET,
  STANDARD_PRICE_EDIT_REQUEST,
  STANDARD_PRICE_EDIT_SUCCESS,
  STANDARD_PRICE_EDIT_FAILURE,
  STANDARD_PRICE_EDIT_RESET,
  STANDARD_PRICE_CREATE_REQUEST,
  STANDARD_PRICE_CREATE_SUCCESS,
  STANDARD_PRICE_CREATE_FAILURE,
  STANDARD_PRICE_CREATE_RESET,
  STANDARD_PRICE_DEACTIVATE_REQUEST,
  STANDARD_PRICE_DEACTIVATE_SUCCESS,
  STANDARD_PRICE_DEACTIVATE_FAILURE,
  STANDARD_PRICE_DEACTIVATE_RESET,
  STANDARD_PRICE_EXPORT_REQUEST,
  STANDARD_PRICE_EXPORT_SUCCESS,
  STANDARD_PRICE_EXPORT_FAILURE,
  STANDARD_PRICE_EXPORT_RESET,

} from './../../constants'

export function createStandardPrice(payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/standard-prices`,
      method: 'POST',
      types: [
        STANDARD_PRICE_CREATE_REQUEST,
        STANDARD_PRICE_CREATE_SUCCESS,
        STANDARD_PRICE_CREATE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function getStandardPrice(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/standard-prices`,
      method: 'GET',
      types: [
        STANDARD_PRICE_LIST_REQUEST,
        STANDARD_PRICE_LIST_SUCCESS,
        STANDARD_PRICE_LIST_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function getStandardPriceByID(id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/standard-prices/${id}`,
      method: 'GET',
      types: [
        STANDARD_PRICE_GET_REQUEST,
        STANDARD_PRICE_GET_SUCCESS,
        STANDARD_PRICE_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function editStandardPrice(id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/standard-prices/${id}`,
      method: 'PUT',
      types: [
        STANDARD_PRICE_EDIT_REQUEST,
        STANDARD_PRICE_EDIT_SUCCESS,
        STANDARD_PRICE_EDIT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function deactivateStandardPrice(id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/standard-prices/${id}/delete`,
      method: 'PUT',
      types: [
        STANDARD_PRICE_DEACTIVATE_REQUEST,
        STANDARD_PRICE_DEACTIVATE_SUCCESS,
        STANDARD_PRICE_DEACTIVATE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}
export function exportStandardPrice(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/standard-prices/exports`,
      method: 'GET',
      types: [
        STANDARD_PRICE_EXPORT_REQUEST,
        STANDARD_PRICE_EXPORT_SUCCESS,
        STANDARD_PRICE_EXPORT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function resetListStandardPrice() {
  return {
    type: STANDARD_PRICE_LIST_RESET,
  }
}
export function resetCreateStandardPrice() {
  return {
    type: STANDARD_PRICE_CREATE_RESET,
  }
}
export function resetEditStandardPrice() {
  return {
    type: STANDARD_PRICE_EDIT_RESET,
  }
}
export function resetGetStandardPrice() {
  return {
    type: STANDARD_PRICE_GET_RESET,
  }
}
export function resetDeactivateStandardPrice() {
  return {
    type: STANDARD_PRICE_DEACTIVATE_RESET,
  }
}
export function resetExportStandardPrice() {
  return {
    type: STANDARD_PRICE_EXPORT_RESET,
  }
}




// WEBPACK FOOTER //
// ./src/actions/standard-price/standard-price-action.js